module.exports = __webpack_public_path__ + "roboto-v15-latin-700.128879da78c6c8eb4e2c.eot";


//////////////////
// WEBPACK FOOTER
// A:/CM/links-ui/cm-ui-app-links/src/assets/layout/fonts/roboto-v15-latin-700.eot
// module id = ../../../../../src/assets/layout/fonts/roboto-v15-latin-700.eot
// module chunks = styles